export type IListWithEdges = {
  list: {
    edges: Array<{ node: any }>;
  };
};

type IList = { list: Array<any> };

type IListDataWithEdges = {
  listData: {
    edges: Array<{ node: any }>;
  };
};

/**
 * Unwrap query data (i.e. edges) into a regular array of entities.
 */
export const processData: (data: IList | IListWithEdges | IListDataWithEdges | Array<any>) => Array<any> = (data) => {
  const edges: Array<any> | undefined =
    (data as IListWithEdges)?.list?.edges || (data as IListDataWithEdges)?.listData?.edges;
  if (edges) {
    return edges.map((item) => {
      return {
        ...item.node,
      };
    });
  } else if ((data as IList)?.list) {
    return [...(data as IList).list];
  } else if (Array.isArray(data)) {
    return data;
  }
  return [];
};
